import { type FC } from "react";
import { useSelector } from "react-redux";
import { selectBaseDesignation } from "~/features/configurator/Linear/redux/selectors";
import classNames from "classnames";
import Card from "~/common/components/Card";
import { Link, LinkType } from "~/common/components/Link";
import { selectDataComponent } from "~/features/configurator/common/components/ConfigurationSummarySubstep";
import { ToggleIcon } from "~/common/components/icon/ToggleIcon";
import { useTranslation } from "react-i18next";

interface Props {
  isOpen: boolean;
  setIsOpen: (isOpen: boolean) => void;
}

export const LinearProductReviewCard: FC<Props> = ({ setIsOpen }) => {
  const SummaryData = useSelector(selectDataComponent);

  return (
    <Card className={"scha__lc__review__card"}>
      <div className={"scha__lc__summary--review"}>
        <SummaryData isFullReview={false} onStepChange={() => setIsOpen(false)} />
      </div>
    </Card>
  );
};
export const LinearProductReviewButton: FC<Props> = ({ isOpen, setIsOpen }) => {
  const baseDesign = useSelector(selectBaseDesignation);

  const { t } = useTranslation();

  const onClick = () => {
    setIsOpen(!isOpen);
  };

  return (
    <div className={classNames("d-flex flex-direction-column scha__lc__review", isOpen && "active")}>
      <Link onClick={onClick} variant={LinkType.SECONDARY}>
        <span className={"icon-margin scha__lc__review__btn"}>{t("page.linear.summary.review.edit")}</span>
        <ToggleIcon isActive={isOpen} />
      </Link>
      <p className={"scha__lc__review__selected"}>
        <span className={"f-label-color"}>{t("page.linear.summary.review.designType")} </span>
        <span>{baseDesign}</span>
      </p>
    </div>
  );
};
